import React from 'react';
import {
  Box,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Paper,
  Typography,
  Divider
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import useResponsive from '../hooks/useResponsive';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isSmallScreen, isMediumScreen } = useResponsive();  // Detect screen sizes

  const menuItems = [
    { text: 'Home Loan', path: '/home-loan' },
    { text: 'Docs Required for Home Loan', path: '/docs-required' },
    { text: 'Property Buying Steps', path: '/property-buying-steps' },
    { text: 'EMI Calculator', path: '/emi-calculator' },
    { text: "FAQ'S", path: '/faqs' },
    { text: "Blogs", path: '/blogs' },
    { text: 'Vaastu Tips', path: '/vaastu-tips' },
    { text: 'Builder Partners', path: '/builder-partners' }
  ];


  const handleNavigation = (path) => {
    navigate(path);
  };

  // Sidebar content component for reuse
  const sidebarContent = (
    <Box>
      <Paper elevation={2}
        sx={{
          width: isSmallScreen || isMediumScreen ? '100%' : 280, height: '100vh', borderRadius: 0, boxShadow: 'none',
          borderRight: '1px solid #e0e0e0'
        }}
      >
        <Box sx={{ p: 2 }}>
          <Typography variant="h6" sx={{ color: '#333', fontWeight: 600 }}>  Quick Links</Typography>
        </Box>
        <Divider />
        <List sx={{ p: 0, boxShadow: 'none' }}>
          {menuItems.map((item, index) => (
            <ListItem key={index} disablePadding>
              <ListItemButton
                onClick={() => handleNavigation(item.path)}
                sx={{
                  py: 0.5, px: 1.5,
                  bgcolor: location.pathname === item.path ? '#ebced0ff' : 'transparent',
                  borderLeft: location.pathname === item.path ? '4px solid #BB081B' : '4px solid transparent',
                  '&:hover': {
                    bgcolor: '#ebced0ff', // Set the hover background color to #ebced0ff
                  },
                }}
              >
                <ListItemText
                  primary={item.text}
                  primaryTypographyProps={{
                    fontSize: '0.95rem',
                    color: location.pathname === item.path ? '#fff' : '#555',
                    fontWeight: location.pathname === item.path ? 600 : 400
                  }}
                />
              </ListItemButton>
            </ListItem>
          ))}
        </List>
      </Paper>


    </Box>

  );

  // If on small or medium screens, do not render the sidebar
  if (isSmallScreen || isMediumScreen) {
    return null; // Return null to hide the sidebar on small and medium screens
  }

  // Desktop view: render sidebar directly
  return (
    <Box sx={{ mt: 12 }}>
      {sidebarContent}
    </Box>
  );
};

export default Sidebar;
